// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__20Mqs","inputWrap":"Table_inputWrap__21N5F","col":"Table_col__vO1ck","bmiTooltip":"Table_bmiTooltip__1IjYi"};